<template>
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    class="tw-h-5 tw-w-5 dark:tw-text-white"
  >
    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12h-15"></path>
  </svg>
</template>

<script>
export default {
  name: 'Minus'
};
</script>
